export default __webpack_public_path__ + "static/media/ico_inquiry.1051a576.svg";